module.exports = __webpack_public_path__ + "static/media/ticket.2f1d6a67.svg";